import axios from "axios";

export let BASE_URL = "https://cipl.aimantra.info";
// BASE_URL = "https://ksncfd6v-8007.inc1.devtunnels.ms";


export const APPLY_URL = "https://www.cipl.aimantrahrms.com/personaldetails";
export const MEDIA_URL =
  "https://civilmantra.s3.ap-south-1.amazonaws.com/Saptagon-website-images/SaptagonAssets/";

export const MEDIA_URL2 =
  "https://civilmantra.s3.ap-south-1.amazonaws.com/civilmantra-website-images/CivilmantraAssets%5B1%5D/CivilmantraAssets/";

export const API = axios.create({
  baseURL: BASE_URL, headers: {
    'Content-Type': 'application/json'
  }
});
